import $ from 'jquery';
$(document).on('click', '.message__dismiss', function () {
  $(this).closest('.message').slideUp('fast');
});